import type { IconDefinition } from '../index.tsx';

export const iconMaximize: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconMaximize',
  icon: [
    16,
    16,
    [],
    '',
    'M10 0L9 1L11.2929 3.29289L8.29289 6.29289L9.70711 7.70711L12.7071 4.70711L15 7L16 6L16 0H10Z M0 16H6L7 15L4.70711 12.7071L7.70711 9.70711L6.29289 8.29289L3.29289 11.2929L1 9L0 10V16Z',
  ],
};
